// extracted by mini-css-extract-plugin
module.exports = {"Logo":"ProfilePhoto_Logo__DuQFH","img":"ProfilePhoto_img__1_9T1"};